<template>
  <v-dialog v-model="dialog.show" max-width="600" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row justify="center">
            <v-col cols="12">
              <v-card>
                <v-card-title>De</v-card-title>
                <v-card-text>
                  <v-text-field v-model="colaborador.nome" disabled></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="2">
              <v-btn outlined color="blue darken-1" medium rounded depressed>
                <v-icon>mdi-arrow-down-bold</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-card>
                <v-card-title>Para</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <SelectEquipesBySupervisor
                        @onChanged="colaboradores = $event; changeSelectEquipe()"
                      />
                    </v-col>
                    <v-col cols="12">
                      <SelectByColaboradoresByEquipe
                        @onChanged="colaboradorSelected = $event"
                        :colaboradores="colaboradores"
                        :disabled="disableSelectColaboradores"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Supervisor, Vendedor } from "@/services/lead";

export default {
  name: "DialogMovimentar",

  components: {
    SelectEquipesBySupervisor: () => import("./SelectEquipesBySupervisor"),
    SelectColaboradoresByEquipe: () => import("./SelectColaboradoresByEquipe")
  },

  data() {
    return {
      dialog: {
        show: false,
        title: "Movimentar Lead"
      },
      lead: "",
      colaborador: "",
      colaboradores: [],
      colaboradorSelected: [],
      disableSelectColaboradores: true,
      serviceLeadsSupervisor: new Supervisor(),
      serviceLeadsVendedor: new Vendedor()
    };
  },

  methods: {
    async show(lead) {
      try {
        await this.getColaborador(lead);
        this.lead = lead;
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async save() {
      try {
        if (this.$refs.form.validate()) {
          const response = await this.serviceLeadsSupervisor.moveLeads(
            this.lead,
            this.colaboradores.filter(
              colaborador => colaborador.colaborador == this.colaboradorSelected
            )[0].cpf_completo
          );
          this.close();
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async getColaborador(lead) {
      try {
        const response = await this.serviceLeadsVendedor.getColaborador(lead);
        this.colaborador = response[0];
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
      this.disableSelectColaboradores = true;
    },

    changeSelectEquipe() {
      this.disableSelectColaboradores = false;
    }
  }
};
</script>
